<form
  [formGroup]="form"
  (dragover)="onDragOver($event)"
  (drop)="onFileDrop($event)"
  (ngSubmit)="onSubmit()">
  <div class="bn-dialog bn-shield-create-edit-access-list-modal">
    <div
      class="bn-dialog__close z-0"
      (click)="onClose()">
      <fa-icon
        aria-label="Close"
        icon="xmark"
        size="lg" />
    </div>
    @if (icon) {
      <div class="bn-dialog__icon">
        <fa-icon
          size="1x"
          [icon]="icon" />
      </div>
    }
    <div class="bn-dialog__title text-center">{{ isEdit ? 'Edit list: ' + form.controls.name.value : 'Add a list' }}</div>
    <div class="bn-dialog__body">
      <div class="text-center">{{ isEdit ? 'Add or remove values (one per line)' : 'Upload or copy paste' }}</div>
      <div class="mt-4 position-relative">
        <bn-web-ui-textarea
          formControlName="content"
          placeholder="Enter or paste {{ selectedTypeName }}, one per line"
          rows="8" />
        <div
          class="bn-shield-create-edit-access-list-modal__upload"
          [ngClass]="{
            'bn-shield-create-edit-access-list-modal__upload--error': form.controls.content.invalid && form.controls.content.touched,
          }"
          (click)="fileInput.click()">
          <input
            #fileInput
            accept="txt"
            class="d-none"
            name="avatar"
            type="file"
            (change)="onUploadCallback($event)" />
          <fa-icon
            aria-label="Upload file"
            icon="file-arrow-up"
            size="1x" />
        </div>
      </div>
      <div class="mt-4">
        <bn-web-ui-input
          formControlName="name"
          inputName="List name"
          label="List name"
          placeholder="Your list name" />
      </div>
      <div class="mt-4">
        <bn-web-ui-select
          formControlName="listType"
          label="List type"
          size="sm"
          [items]="listTypeItems"
          [options]="{ placeholder: 'Choose type', leftIcon: 'file-lines' }" />
      </div>
      <!-- <div class="mt-4">
      <div class="bn-form__label d-flex">List action</div>
      <bn-web-ui-radio-tabs
        label="List action"
        [disabled]="isEdit ?? false"
        formControlName="listAction"
        [items]="listActionItems">
      </bn-web-ui-radio-tabs>
    </div> -->
    </div>
    @if (errorMessage || isAddError() || isUpdateError()) {
      <bn-web-ui-alert
        alertType="danger"
        class="text-start mt-2"
        headerIcon="circle-exclamation"
        [showIcon]="true">
        @if (errorMessage) {
          {{ errorMessage }}
        }
        <!---->
        @if (isAddError()) {
          <span>There was an error while trying to add a custom access list: <br />{{ getAddErrorMessage() }}</span>
        }
        <!---->
        @if (isUpdateError()) {
          <span>There was an error while trying to update a custom access list: <br />{{ getUpdateErrorMessage() }}</span>
        }
      </bn-web-ui-alert>
    }
    <div class="bn-dialog__actions row mt-4 g-0">
      <div class="col-6 pe-2">
        <button
          bn-web-ui-button
          itemStyle="primary"
          size="lg"
          type="submit"
          [fullWidth]="true"
          [loading]="isAddLoading() || isUpdateLoading()">
          {{ isEdit ? 'Update' : 'Add' }} a List
        </button>
      </div>
      <div class="col-6">
        <button
          bn-web-ui-button
          itemStyle="stroke"
          size="lg"
          type="button"
          [fullWidth]="true"
          (click)="onClose()">
          Cancel
        </button>
      </div>
    </div>
  </div>
  @if (isDragging) {
    <div
      class="bn-shield-create-edit-access-list-modal__drag d-flex align-items-center justify-content-center p-4"
      (dragleave)="onDragLeave($event)">
      <div class="bn-shield-create-edit-access-list-modal__drag__content">
        <div class="text-center pe-none">
          <fa-icon
            aria-label="Upload"
            icon="upload"
            size="2x" />
          <div class="text-400-semi-bold text-dark-8 mt-4">Drag & Drop txt file to upload</div>
          <div class="text-400-regular text-dark-6 mt-2">Your text file should have one item per line.</div>
        </div>
      </div>
    </div>
  }
</form>
@if (isDetailsLoading()) {
  <bn-web-ui-loading size="sm" />
}
